import React from 'react'

export default function Info4() {
  return (
    <section id='servicios' className="services-section py-16 md:py-24 bg-base-200">
      <div className="container mx-auto  md:px-8">
        <div className="text-center mb-12 md:mb-16">
          <h1 className="h1-info4 text-3xl md:text-4xl lg:text-5xl font-bold piel2">
          ¿Qué puedes hacer?
          </h1>
        </div>
        <div className='grid grid-cols-1 md:grid-cols-2 '>
        <div className="div-info4 grid grid-cols-1 md:grid-cols-2 max-w-7xl mx-auto fade-in-on-scroll margin-iz">
          
        <div style={{justifySelf:'center', textAlign:'left'}} className="card bg-no  w-full">
            <div className="flex">
                <div className='tarjeta-vd redondo'> 

                </div>
                <div>
              <h2 className="font-bold  piel">Reduce tu huella de carbono</h2>
              <p className='nobile piel2'>Elige transporte público, bicicleta o caminar, consume productos locales y reduce el consumo de energía.</p>
              </div>
            
            </div>
          </div>

          <div style={{justifySelf:'center', textAlign:'left'}} className="card bg-no  w-full">
            <div className="flex">
                <div className='tarjeta-vd redondo'> 

                </div>
                <div>
              <h2 className="font-bold  piel">Apoya las energías renovables</h2>
              <p className='nobile piel2'>Invierte en energía solar, eólica o hidráulica y apoya a empresas con prácticas sostenibles.</p>
              </div>
            
            </div>
          </div>

          <div style={{justifySelf:'center', textAlign:'left'}} className="card bg-no  w-full">
            <div className="flex">
                <div className='tarjeta-vd redondo'> 

                </div>
                <div>
              <h2 className="font-bold  piel">Defiende la acción climática</h2>
              <p className='nobile piel2'>Informa a tus representantes políticos sobre la necesidad de políticas climáticas ambiciosas.</p>
              </div>
            
            </div>
          </div>

          <div style={{justifySelf:'center', textAlign:'left'}} className="card bg-no  w-full">
            <div className="flex">
                <div className='tarjeta-vd redondo'> 

                </div>
                <div>
              <h2 className="font-bold  piel">Mide tu impacto</h2>
              <p className='nobile piel2'>Utiliza herramientas y calculadoras para cuantificar tu huella de carbono y monitorea tu progreso en reducirla.</p>
              </div>
            
            </div>
          </div>


          

          

          
          

          
        </div>
        <div className='grid grid-cols-1 md:grid-cols-1'>
            <img className='img-fn' src='img/9.webp' />
            
        </div>
        </div>
      </div>
    </section>
  )
}
